<template>
    <div class="user-video-component col-md-4">
      
      <h2>{{ msg }}</h2>
      
    </div>
  </template>
  
  <script>
  import MediaDevices from 'janus-gateway-tsdx';
  import Client from 'janus-gateway-tsdx';

  export default {
    name: 'UserVideoComponent',
    data () {
      return {
        msg: 'UserVideoComponent'
      }
    }
  }
  </script>


  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/UserVideoComponent.vue